<template>
  <div class="ChatHistory">
    <ul class="ChatHistory__list">
      <li v-for="chat in chats" :key="chat.id" class="ChatHistory__item">
        <ChatHistoryRow
          :chat="chat"
          :showContextMenu="showContextMenu"
          @onChatClick="$emit('onChatClick')"
        />
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
import type { IChatListItem } from '@/apiClient/types/chat'

import ChatHistoryRow from './ChatHistoryRow.vue'

defineEmits(['onChatClick'])
withDefaults(
  defineProps<{
    chats?: IChatListItem[]
    /**
     * If true, the context menu will be shown when the user hovers on a chat
     */
    showContextMenu?: boolean
  }>(),
  {
    chats: () => [],
    showContextMenu: true,
  },
)
</script>

<style scoped lang="scss">
.ChatHistory {
  .ChatHistory__list {
    margin: 0;
    padding: 0;
  }

  .ChatHistory__item {
    list-style: none;
  }
}
</style>
